import { firestore } from '@/firebase'

const users = firestore.collection('users')
const usersMetaData = firestore.collection('users-metadata')
const projects = firestore.collection('projects')

const templates = firestore.collection('published-templates')

export {
	users,
	usersMetaData,
	projects,
	templates
}
